/*
  How-To: вкладки, поиск, фильтры хаков и отметки шагов.

  Страница одна, а видов пять: START HERE, ASSEMBLE, HACKS, TOOLS, BLOG.
  Секции помечены data-mr-view, строка вкладок решает, какой вид виден.
  Вид живёт в адресе (#hacks), поэтому ссылку на вкладку можно отправить,
  а пункты меню ведут сразу в нужный вид. Адрес #hack-<id> открывает HACKS
  на этой карточке.

  Скрипт подключается строкой вкладок без defer: класс вида ставится на
  <html> до того, как браузер нарисует секции ниже, и страница не мигает
  всеми видами сразу. Без JavaScript класса нет, и виды стоят друг под
  другом - инструкция читается целиком.

  Редактор темы запускает скрипт секции заново при каждой правке. Слушатели
  вешаются один раз (window.mrHowto), а вид, поиск и отметки
  перерисовываются при каждом запуске.
*/
(function () {
  var VIEWS = ['overview', 'assemble', 'hacks', 'tools', 'blog'];
  var DONE_KEY = 'mr-howto-done';
  var html = document.documentElement;
  var state = window.mrHowto || (window.mrHowto = { filters: { need: '', topic: '', q: '' }, bound: false });
  var filters = state.filters;

  function hashId() {
    var raw = (location.hash || '').slice(1);
    try { return decodeURIComponent(raw); } catch (e) { return raw; }
  }

  function viewFromHash() {
    var id = hashId();
    if (id.indexOf('hack-') === 0) return 'hacks';
    return VIEWS.indexOf(id) === -1 ? 'overview' : id;
  }

  function currentView() {
    for (var i = 0; i < VIEWS.length; i++) {
      if (html.classList.contains('mr-view-' + VIEWS[i])) return VIEWS[i];
    }
    return 'overview';
  }

  function setView(view) {
    if (VIEWS.indexOf(view) === -1) view = 'overview';
    VIEWS.forEach(function (v) { html.classList.toggle('mr-view-' + v, v === view); });
    document.querySelectorAll('[data-mr-tab]').forEach(function (tab) {
      var on = tab.getAttribute('data-mr-tab') === view;
      tab.classList.toggle('is-on', on);
      if (on) tab.setAttribute('aria-current', 'true'); else tab.removeAttribute('aria-current');
    });
    return view;
  }

  setView(viewFromHash());
  html.classList.add('mr-views');

  function writeHash(value) {
    if (history.replaceState) history.replaceState(null, '', '#' + value);
  }

  // Высота липкой строки нужна карточкам хаков: переход по #hack-... не
  // должен прятать карточку под строкой. На узком экране строка выше.
  function measureBar() {
    var bar = document.querySelector('[data-mr-howto]');
    if (bar) html.style.setProperty('--mr-tabs-h', bar.offsetHeight + 'px');
  }

  // Новый вид открывается с начала, а не с того места, где человек читал
  // предыдущий. Липнет обёртка секции вкладок, поэтому её место в потоке
  // считается по низу секции над ней: у прилипшей обёртки верх всегда 0.
  function toTop() {
    var bar = document.querySelector('[data-mr-howto]');
    var wrap = bar && (bar.closest('.shopify-section') || bar);
    if (!wrap) return;
    var prev = wrap.previousElementSibling;
    var y = prev ? prev.getBoundingClientRect().bottom + window.pageYOffset : 0;
    if (window.pageYOffset <= y) return;
    var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: y, behavior: calm ? 'auto' : 'smooth' });
  }

  function showView(view) {
    writeHash(setView(view));
    toTop();
  }

  // Слова, а не строка целиком: «No brads?» должен находить «No brads - what
  // holds it together?», знаки препинания в вопросе не мешают.
  function words(text) {
    return text.toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim().split(' ').filter(Boolean);
  }

  function filterHacks() {
    var box = document.querySelector('[data-mr-hacks]');
    if (!box) return;
    var wanted = words(filters.q);
    var shown = 0;
    box.querySelectorAll('[data-mr-hack]').forEach(function (card) {
      var needs = ' ' + (card.getAttribute('data-need') || '') + ' ';
      var find = card.getAttribute('data-find') || '';
      var ok = (!filters.need || needs.indexOf(' ' + filters.need + ' ') !== -1) &&
        (!filters.topic || card.getAttribute('data-topic') === filters.topic) &&
        wanted.every(function (w) { return find.indexOf(w) !== -1; });
      card.hidden = !ok;
      if (ok) shown++;
    });
    box.querySelectorAll('[data-mr-need]').forEach(function (chip) {
      chip.setAttribute('aria-pressed', String(chip.getAttribute('data-mr-need') === filters.need));
    });
    box.querySelectorAll('[data-mr-topic]').forEach(function (chip) {
      chip.setAttribute('aria-pressed', String(chip.getAttribute('data-mr-topic') === filters.topic));
    });
    var count = box.querySelector('[data-mr-hack-count]');
    if (count) {
      var label = count.getAttribute(shown === 1 ? 'data-one' : 'data-many') || '[count]';
      count.textContent = label.replace('[count]', shown);
    }
    var grid = box.querySelector('[data-mr-hack-grid]');
    var none = box.querySelector('[data-mr-hack-none]');
    if (grid) grid.hidden = shown === 0;
    if (none) none.hidden = shown !== 0;
  }

  function resetFilters() {
    filters.need = '';
    filters.topic = '';
    filters.q = '';
  }

  function syncSearch() {
    document.querySelectorAll('[data-mr-howto-q]').forEach(function (input) {
      if (input.value !== filters.q) input.value = filters.q;
    });
    document.querySelectorAll('[data-mr-howto-clear]').forEach(function (btn) { btn.hidden = !filters.q; });
  }

  function route() {
    var id = hashId();
    var card = id.indexOf('hack-') === 0 ? document.getElementById(id) : null;
    if (card) {
      resetFilters();
      syncSearch();
      filterHacks();
    }
    setView(viewFromHash());
    if (card) card.scrollIntoView({ block: 'start' });
  }

  // Отметки шагов лежат только в браузере человека, на сервер ничего не уходит.
  function readDone() {
    try {
      var list = JSON.parse(localStorage.getItem(DONE_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeDone(list) {
    try { localStorage.setItem(DONE_KEY, JSON.stringify(list)); } catch (e) { /* приватное окно: отметки живут до перезагрузки */ }
  }

  function paintDone() {
    var cards = document.querySelectorAll('[data-mr-step]');
    var done = 0;
    cards.forEach(function (card) {
      var on = state.done.indexOf(card.getAttribute('data-mr-step')) !== -1;
      if (on) done++;
      card.classList.toggle('is-done', on);
      var btn = card.querySelector('[data-mr-step-toggle]');
      if (!btn) return;
      btn.setAttribute('aria-pressed', String(on));
      var label = btn.querySelector('[data-todo]');
      if (label) label.textContent = label.getAttribute(on ? 'data-done' : 'data-todo');
    });
    document.querySelectorAll('[data-mr-progress]').forEach(function (box) {
      var bar = box.querySelector('[data-mr-progress-bar]');
      var count = box.querySelector('[data-mr-progress-count]');
      if (bar) bar.style.width = (cards.length ? done / cards.length * 100 : 0) + '%';
      if (count) {
        count.textContent = (count.getAttribute('data-label') || '[done] / [total]')
          .replace('[done]', done).replace('[total]', cards.length);
      }
    });
  }

  state.done = state.done || readDone();

  function onClick(e) {
    // Клик с Ctrl, Cmd или Shift открывает ссылку в новой вкладке, как везде.
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var el = e.target.closest ? e.target : e.target.parentElement;
    if (!el || !el.closest) return;

    var tab = el.closest('[data-mr-tab]');
    if (tab) {
      e.preventDefault();
      showView(tab.getAttribute('data-mr-tab'));
      return;
    }

    var go = el.closest('[data-mr-go]');
    if (go) {
      e.preventDefault();
      var view = go.getAttribute('data-mr-go');
      if (view === 'hacks') {
        resetFilters();
        filters.need = go.getAttribute('data-mr-go-need') || '';
        syncSearch();
        filterHacks();
      }
      showView(view);
      return;
    }

    var need = el.closest('[data-mr-need]');
    if (need) {
      filters.need = need.getAttribute('data-mr-need');
      filterHacks();
      return;
    }

    var topic = el.closest('[data-mr-topic]');
    if (topic) {
      filters.topic = topic.getAttribute('data-mr-topic');
      filterHacks();
      return;
    }

    if (el.closest('[data-mr-hack-reset]')) {
      resetFilters();
      syncSearch();
      filterHacks();
      return;
    }

    if (el.closest('[data-mr-howto-clear]')) {
      filters.q = '';
      syncSearch();
      filterHacks();
      var input = document.querySelector('[data-mr-howto-q]');
      if (input) input.focus();
      return;
    }

    var toggle = el.closest('[data-mr-step-toggle]');
    if (toggle) {
      var step = toggle.closest('[data-mr-step]').getAttribute('data-mr-step');
      var at = state.done.indexOf(step);
      if (at === -1) state.done.push(step); else state.done.splice(at, 1);
      writeDone(state.done);
      paintDone();
    }
  }

  // Поиск в строке вкладок ищет по хакам: человек спрашивает «нет брадсов»,
  // а ответы на такие вопросы живут там.
  function onInput(e) {
    if (!e.target.matches || !e.target.matches('[data-mr-howto-q]')) return;
    filters.q = e.target.value;
    clearTimeout(state.typing);
    state.typing = setTimeout(function () {
      if (filters.q.trim() && currentView() !== 'hacks') showView('hacks');
      syncSearch();
      filterHacks();
    }, 140);
  }

  function onHash() {
    // Панель HOW-TO в шапке открыта, пока в ней фокус. На этой же странице
    // пункт панели меняет только адрес, и без этого панель висела бы открытой.
    var active = document.activeElement;
    if (active && active.closest && active.closest('.mr-header__panel')) active.blur();
    route();
    if (hashId().indexOf('hack-') !== 0) toTop();
  }

  // В редакторе темы секция из скрытого вида открывает свой вид, иначе её
  // нельзя было бы увидеть, пока правишь.
  function onSectionSelect(e) {
    var el = e.target.querySelector('[data-mr-view]');
    if (el) setView(el.getAttribute('data-mr-view'));
  }

  function refresh() {
    setView(currentView());
    syncSearch();
    filterHacks();
    paintDone();
    measureBar();
  }

  if (!state.bound) {
    state.bound = true;
    document.addEventListener('click', onClick);
    document.addEventListener('input', onInput);
    window.addEventListener('hashchange', onHash);
    window.addEventListener('resize', measureBar);
    document.addEventListener('shopify:section:select', onSectionSelect);
    document.addEventListener('shopify:section:load', refresh);
  }

  function init() {
    route();
    syncSearch();
    filterHacks();
    paintDone();
    measureBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
